package pl.decks.personal.components.widgets.tag

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.toModifier
import pl.decks.personal.components.widgets.tag.TagStylesheet.Tag

@Composable
fun HashTag(
    text: String,
    modifier: Modifier = Modifier,
    variant: CssStyleVariant<Tag.Kind>? = null,
) = SpanText(
    text = "#$text",
    modifier = Tag.Style.toModifier(variant).then(modifier),
)
